define(
    'Slider.View',
    [
        'CustomContentType.Base.View',
        'slider.tpl',
        'jQuery',
        'underscore',
        'jQuery.bxSlider@4.2.14'
    ]
    , function (
        CustomContentTypeBaseView,
        slider_tpl,
        jQuery,
        _
    ) {

        'use strict';

        return CustomContentTypeBaseView.extend({

            template: slider_tpl,

            initialize: function initialize(options) {

                if (options) {
                    this.container = options.container;
                }

                this._initialize();
            },

            install: function (settings, context_data) {

                this._install(settings, context_data);

                var promise = jQuery.Deferred();

                return promise.resolve();
            },

            contextDataRequest: ['item'],

            validateContextDataRequest: function validateContextDataRequest() {

                return true;
            },

            getContext: function getContext() {

                var self = this;

                var initSlider = function (self) {

                    var hasMoreThanOneSlider = (self.$('.tt-slider-main').children().length > 1);

                    if (hasMoreThanOneSlider) {

                        if (!self.$('.bx-wrapper').length) {

                            self.sliderContainer = self.$('.tt-slider-main').bxSliderNew({
                                auto: self.sliderAutoPlay(),
                                pause: self.sliderSpeed(),
                                controls: self.sliderArrowsControls(),
                                pager: self.sliderPagerControls(),
                                pagerCustom: self.sliderCustomPager(self.$('.tt-slider-custom-pager')),
                                nextText: '<a class="tt-slider-next-icon"></a>',
                                prevText: '<a class="tt-slider-prev-icon"></a>',
                                touchEnabled: true,
                                stopAutoOnClick: true,
                                responsive: true,
                                adaptiveHeight: true,
                                adaptiveHeightSpeed: 200,
                                onSliderLoad: function(currentIndex) {
                                    /* Click Links issue fix (v2021.2 issue) */
                                    self.$('.bx-viewport').removeClass('bx-viewport');
                                },
                            });
                        } else {

                            if (self.sliderContainer) {

                                self.sliderContainer.redrawSlider();
                            }
                        }
                    }

                    self.$('.tt-slider-section').addClass('tt-slider-loaded');
                }

                var sliderCollection = this.createSlideshowCollection();

                self.$('.tt-slider-section').ready(function () {

                    if (sliderCollection.imagesOnSlider) {

                        self.$('img').on('load', function (event) {
                            initSlider(self);
                        });
                    } else {

                        initSlider(self);
                    }
                });

                var slideCount = sliderCollection.slides.length === 1 ? 'tt-slider-one-slide' : '';

                var sliderHeights = "";

                if (!sliderCollection.imagesOnSlider) {

                    sliderHeights += !!this.settings.custrecord_ttslider_sliderheight_d ? 'tt-slider-height-desktop-' + this.sliderHeights(this.settings.custrecord_ttslider_sliderheight_d) : '';
                    sliderHeights += !!this.settings.custrecord_ttslider_sliderheight_t ? ' tt-slider-height-tablet-' + this.sliderHeights(this.settings.custrecord_ttslider_sliderheight_t) : '';
                    sliderHeights += !!this.settings.custrecord_ttslider_sliderheight_m ? ' tt-slider-height-mobile-' + this.sliderHeights(this.settings.custrecord_ttslider_sliderheight_m) : '';
                }

                return {
                    lazyLoad: (typeof lazySizes != 'undefined'), // Lazysizes Plugin check
                    oneSlide: slideCount,
                    sliderControlsClasses: this.sliderControlsClasses(),
                    contentContainer: this.settings.custrecord_ttslider_contentcontainer === "T" ? "tt-slider-slide-content-container" : "tt-slider-slide-content-full",
                    background: this.settings.custrecord_ttslider_background,
                    sliderHeights: sliderHeights,
                    slideshowList: sliderCollection.slides,
                    showCustomPager: this.sliderShowCustomPager()
                }
            }

            //// Slider Controls ////

            , sliderAutoPlay: function () {

                return (this.settings.custrecord_ttslider_autoslide === "T");
            }

            , sliderSpeed: function () {
                return (this.settings.custrecord_ttslider_autoslidetime || 5000);
            }

            , sliderArrowsControls: function () {

                return (this.settings.custrecord_ttslider_arrows === "T");
            }

            , sliderPagerControls: function () {

                var showPager = true;

                switch (parseInt(this.settings.custrecord_ttslider_pagertype)) {
                    case 2: showPager = true; break; // Custom Pager
                    case 3: showPager = false; break; // None Pager
                    default: showPager = true; // Default Pager
                }

                return showPager;
            }

            , sliderShowCustomPager: function () {

                return (parseInt(this.settings.custrecord_ttslider_pagertype) === 2);
            }

            , sliderCustomPager: function (customPager) {

                return (parseInt(this.settings.custrecord_ttslider_pagertype) === 2) ? customPager : null;
            }

            , sliderControlsClasses: function () {

                var classes = "";

                classes += this.settings.custrecord_ttslider_controlscontainer === "T" ? "tt-slider-custom-pager-container " : "",
                    classes += "tt-slider-controls-" + this.getColor(this.settings.custrecord_ttslider_controlscolor);
                classes += this.settings.custrecord_ttslider_controlsshadow === "T" ? ' tt-slider-controls-shadow' : '';

                return classes;
            }

            //// Get Slider Data ////

            , createSlideshowCollection: function () {

                var sliderShowCollection = [];
                var slideNumbers = 4;
                var imagesOnSlider = false;

                for (var i = 1; i < (slideNumbers + 1); i++) {

                    var slide = this.createSlide(i);

                    if (!!slide.upperTitle || !!slide.title || !!slide.descriptionDesktop || !!slide.link || !!slide.videoURL || !!slide.imageURL) {

                        sliderShowCollection.push(slide);

                        if (!!slide.imageURL) {
                            imagesOnSlider = true;
                        }
                    }
                }

                return {
                    slides: sliderShowCollection,
                    imagesOnSlider: imagesOnSlider
                };
            }

            , sliderHeights: function (index) {

                switch (index) {
                    case "1": index = '300'; break;
                    case "2": index = '350'; break;
                    case "3": index = '400'; break;
                    case "4": index = '450'; break;
                    case "5": index = '500'; break;
                    case "6": index = '550'; break;
                    case "7": index = '600'; break;
                    case "8": index = '650'; break;
                    case "9": index = '700'; break;
                    case "10": index = '750'; break;
                    default: index = '300';
                }

                return index;
            }

            , createSlide: function (itemNumber) {

                var mediaData = this.mediaValidation(itemNumber);

                return {
                    slideContentStyles: this.slideContentStyles(itemNumber),
                    slideContentClasses: this.slideContentClasses(itemNumber),
                    // Video
                    videoURL: mediaData.desktopVideoURL,
                    desktopFileCabinetVideo: mediaData.desktopFileCabinetVideo,
                    videoMobileURL: mediaData.mobileVideoURL,
                    mobileFileCabinetVideo: mediaData.mobileFileCabinetVideo,
                    // Image
                    imageURL: mediaData.desktopImageURL,
                    imageMobileURL: mediaData.mobileImageURL,
                    imageAlt: this.settings['custrecord_ttslider_imagealt' + itemNumber],
                    // Background
                    background: this.settings['custrecord_ttslider_background' + itemNumber],
                    // Upper Title
                    upperTitleTag: this.getUpperTitleTag(itemNumber),
                    upperTitle: this.settings['custrecord_ttslider_uppertitle' + itemNumber],
                    upperTitleClasses: this.slideUpperTitleClasses(itemNumber),
                    // Title
                    titleTag: this.getTitleTag(itemNumber),
                    title: this.settings['custrecord_ttslider_title' + itemNumber],
                    titleClasses: this.slideTitleClasses(itemNumber),
                    // Description
                    descriptionDesktop: this.settings['custrecord_ttslider_description' + itemNumber + '_d'],
                    descriptionMobile: this.settings['custrecord_ttslider_description' + itemNumber + '_m'],
                    descriptionClasses: this.slideDescriptionClasses(itemNumber),
                    // Button
                    buttonText: this.settings['custrecord_ttslider_button' + itemNumber],
                    buttonClasses: this.slideButtonClass(itemNumber),
                    link: this.settings['custrecord_ttslider_buttonlink' + itemNumber],
                    // Content Spacing
                    textSpacing: this.textSpacing(),
                    buttonSpacing: this.buttonSpacing(),
                    // Pager
                    customPagerText: (this.settings['custrecord_ttslider_custompager' + itemNumber]) || ('slide 0' + itemNumber)
                };
            }

            , existData: function (mainData) {

                return ((typeof mainData !== "undefined") && (mainData !== ""));
            }

            , mediaValidation: function (itemNumber) {

                // Desktop Video
                var desktopVideoURL = this.settings['custrecord_ttslider_video' + itemNumber + '_d'];
                desktopVideoURL = (typeof desktopVideoURL === "undefined") ? '' : desktopVideoURL;
                var desktopFileCabinetVideo = (desktopVideoURL.indexOf("http") < 0);
                // Mobile Video
                var mobileVideoURL = this.settings['custrecord_ttslider_video' + itemNumber + '_m'];
                mobileVideoURL = (typeof mobileVideoURL === "undefined") ? '' : mobileVideoURL;
                var mobileFileCabinetVideo = (mobileVideoURL.indexOf("http") < 0);
                // Images
                var desktopImageURL = desktopVideoURL === '' ? this.settings['custrecord_ttslider_image' + itemNumber + '_d'] : '';
                desktopImageURL = (typeof desktopImageURL === "undefined") ? '' : desktopImageURL;
                var mobileImageURL = mobileVideoURL === '' ? this.settings['custrecord_ttslider_image' + itemNumber + '_m'] : '';
                mobileImageURL = (typeof mobileImageURL === "undefined") ? '' : mobileImageURL;

                return {
                    desktopVideoURL: desktopVideoURL,
                    desktopFileCabinetVideo: desktopFileCabinetVideo,
                    mobileVideoURL: mobileVideoURL,
                    mobileFileCabinetVideo: mobileFileCabinetVideo,
                    desktopImageURL: desktopImageURL,
                    mobileImageURL: mobileImageURL
                };
            }

            , slideContentStyles: function (itemNumber) {

                var styles = 'style="';
                // General Styles
                styles += 'padding: ' + this.settings.custrecord_ttslider_padding + 'px;';
                var marginbottom = parseInt(this.settings.custrecord_ttslider_offsetvertical) + 30;
                styles += 'margin: ' + this.settings.custrecord_ttslider_offsetvertical + 'px ' + this.settings.custrecord_ttslider_offsethorizontal + 'px ' + marginbottom + 'px;';
                // Slide Styles
                var minwidth = this.settings['custrecord_ttslider_contentminwidth' + itemNumber];
                styles += this.existData(minwidth) ? 'min-width: ' + minwidth + ';' : '';
                var maxwidth = this.settings['custrecord_ttslider_contentmaxwidth' + itemNumber];
                styles += this.existData(maxwidth) ? 'max-width: ' + maxwidth + ';' : '';
                var backgroundcolor = this.settings['custrecord_ttslider_backgroundcolor' + itemNumber];
                styles += this.existData(backgroundcolor) ? 'background-color: ' + backgroundcolor + ';' : '';

                return styles + '"';
            }

            , slideContentClasses: function (itemNumber) {

                var classes = '';
                // General Classes
                classes += " tt-slider-slide-content-pos-desktop-" + this.getPositionValues(this.settings.custrecord_ttslider_verticalposition_d, this.settings.custrecord_ttslider_horizontalposition_d);
                classes += " tt-slider-slide-content-pos-mobile-" + this.getPositionValues(this.settings.custrecord_ttslider_verticalposition_m, this.settings.custrecord_ttslider_horizontalposition_m);
                classes += " tt-slider-slide-content-align-desktop-" + this.getHorizontalAlign(this.settings.custrecord_ttslider_textalignment_d);
                classes += " tt-slider-slide-content-align-mobile-" + this.getHorizontalAlign(this.settings.custrecord_ttslider_textalignment_m);
                classes += this.settings.custrecord_ttslider_contborderradius === "T" ? " tt-slider-slide-content-border-radius" : "";
                // Slide Classes
                classes += " " + this.getTextColor(this.settings['custrecord_ttslider_textcolor' + itemNumber]);
                classes += " " + this.getTextShadow(this.settings['custrecord_ttslider_textshadow' + itemNumber]);

                return classes;
            }

            , videoHeight: function (videoHeight) {

                return ((typeof videoHeight === "undefined") ? '' : 'style="height: ' + videoHeight + 'px;"');
            }

            , getUpperTitleTag: function (itemNumber) {

                var tag = parseInt(this.settings['custrecord_ttslider_uppertitletag' + itemNumber]);

                switch (tag) {
                    case 2: tag = 'h3'; break;
                    case 3: tag = 'h4'; break;
                    case 4: tag = 'h5'; break;
                    case 5: tag = 'h6'; break;
                    default: tag = 'h3';
                }

                return tag;
            }

            , getTitleTag: function (itemNumber) {

                var tag = parseInt(this.settings['custrecord_ttslider_titletag' + itemNumber]);

                switch (tag) {
                    case 2: tag = 'h2'; break;
                    case 3: tag = 'h3'; break;
                    case 4: tag = 'h4'; break;
                    case 5: tag = 'h5'; break;
                    default: tag = 'h1';
                }

                return tag;
            }

            , slideUpperTitleClasses: function (itemNumber) {

                var classes = '';

                classes += "tt-slider-font-size-" + this.getFontSize(this.settings['custrecord_ttslider_uppertitlefontsize' + itemNumber]);
                classes += " tt-slider-font-weight-" + this.getFontWeight(this.settings['custrecord_ttslider_uppertitlefontwgt' + itemNumber]);

                return classes;
            }

            , slideTitleClasses: function (itemNumber) {

                var classes = '';

                classes += "tt-slider-font-size-" + this.getFontSize(this.settings['custrecord_ttslider_titlefontsize' + itemNumber]);
                classes += " tt-slider-font-weight-" + this.getFontWeight(this.settings['custrecord_ttslider_titlefontwgt' + itemNumber]);

                return classes;
            }

            , slideDescriptionClasses: function (itemNumber) {

                var classes = '';

                classes += "tt-slider-font-size-" + this.getFontSize(this.settings['custrecord_ttslider_descriptionfontsize' + itemNumber]);
                classes += " tt-slider-font-weight-" + this.getFontWeight(this.settings['custrecord_ttslider_descriptionfontwgt' + itemNumber]);

                return classes;
            }

            , slideButtonClass: function (itemNumber) {

                var buttonStyle = parseInt(this.settings['custrecord_ttslider_buttonstyle' + itemNumber]);

                switch (buttonStyle) {
                    case 2: buttonStyle = 'secondary'; break;
                    case 3: buttonStyle = 'tertiary'; break;
                    case 4: buttonStyle = 'quaternary'; break;
                    case 5: buttonStyle = 'link'; break;
                    default: buttonStyle = 'primary';
                }

                return 'tt-slider-button-' + buttonStyle;
            }

            , getPositionValues: function (vartical_setting, horizontal_setting) {

                var vertical_position = parseInt(vartical_setting);
                var horizontal_position = this.getHorizontalAlign(horizontal_setting);

                switch (vertical_position) {
                    case 2: vertical_position = 'top'; break;
                    case 3: vertical_position = 'bottom'; break;
                    default: vertical_position = 'center'; // 1
                }

                return vertical_position + "-" + horizontal_position;
            }

            , getHorizontalAlign: function (horizontal_setting) {

                var horizontal_position = parseInt(horizontal_setting);

                switch (horizontal_position) {
                    case 2: horizontal_position = 'left'; break;
                    case 3: horizontal_position = 'right'; break;
                    default: horizontal_position = 'center'; // 1 
                }

                return horizontal_position;
            }

            , getColor: function (color) {

                var textColor = parseInt(color);

                switch (textColor) {
                    case 2: textColor = 'dark'; break;
                    case 3: textColor = 'light'; break;
                    default: textColor = 'default';
                }

                return textColor;
            }

            , getTextColor: function (textColor) {

                return "text-style-" + this.getColor(textColor);
            }

            , getTextShadow: function (textShadow) {

                return textShadow === "T" ? "text-shadow" : "";
            }

            , getFontSize: function (textFontSize) {

                textFontSize = parseInt(textFontSize);

                switch (textFontSize) {
                    case 1: textFontSize = 'xs'; break;
                    case 2: textFontSize = 's'; break;
                    case 3: textFontSize = 'm'; break;
                    case 4: textFontSize = 'l'; break;
                    case 5: textFontSize = 'xl'; break;
                    case 6: textFontSize = 'xxl'; break;
                    case 7: textFontSize = 'xxxl'; break;
                    default: textFontSize = 'm';
                }

                return textFontSize;
            }

            , getFontWeight: function (fontWeight) {

                fontWeight = parseInt(fontWeight);

                switch (fontWeight) {
                    case 2: fontWeight = 'light'; break;
                    case 3: fontWeight = 'semibold'; break;
                    case 4: fontWeight = 'bold'; break;
                    default: fontWeight = 'normal';
                }

                return fontWeight;
            }

            , textSpacing: function () {

                return 'style="margin-bottom:' + this.settings.custrecord_ttslider_textspacing + 'px"';
            }

            , buttonSpacing: function () {

                return 'style="margin-top:' + this.settings.custrecord_ttslider_buttonspacing + 'px"';
            }

        });

    }
);
